import React from 'react';
import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { AtonFilters } from './types';
import { FilterTrigger } from '../../components/FilterTrigger';

interface AtonFilterProps {
  atonFilters: AtonFilters;
  setAtonFilters: React.Dispatch<React.SetStateAction<AtonFilters>>;
  availableOwners: string[];
}

export const AtonFilter = ({
  atonFilters,
  setAtonFilters,
  availableOwners,
}: AtonFilterProps) => {
  // Count active filters
  const getActiveFiltersCount = () => {
    let count = 0;
    if (atonFilters.type !== 'all') count++;
    if (atonFilters.state !== 'all') count++;
    if (atonFilters.owner !== 'all') count++;
    return count;
  };

  const activeFiltersCount = getActiveFiltersCount();

  return (
    <DropdownMenu>
      <Tooltip>
        <DropdownMenuTrigger asChild>
          <TooltipTrigger asChild>
            <FilterTrigger
              activeFilterCount={activeFiltersCount}
            ></FilterTrigger>
          </TooltipTrigger>
        </DropdownMenuTrigger>
        <TooltipContent>
          {activeFiltersCount > 0
            ? `Filter AtoNs (${activeFiltersCount} active)`
            : 'Filter AtoNs'}
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end" className="w-64 p-4 space-y-4">
        <div className="flex items-center justify-between">
          <div className="font-semibold text-sm">Filter AtoNs</div>
          {activeFiltersCount > 0 && (
            <Badge variant="secondary" className="text-xs">
              {activeFiltersCount} active
            </Badge>
          )}
        </div>

        {/* Type Filter */}
        <div className="space-y-2">
          <div className="text-sm font-medium">Type</div>
          <Select
            value={atonFilters.type}
            onValueChange={(value) =>
              setAtonFilters((prev) => ({
                ...prev,
                type: value as AtonFilters['type'],
              }))
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Types</SelectItem>
              <SelectItem value="physical">Physical</SelectItem>
              <SelectItem value="virtual">Virtual</SelectItem>
              <SelectItem value="synthetic">Synthetic</SelectItem>
              <SelectItem value="host">Host</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* State Filter */}
        <div className="space-y-2">
          <div className="text-sm font-medium">State</div>
          <Select
            value={atonFilters.state}
            onValueChange={(value) =>
              setAtonFilters((prev) => ({
                ...prev,
                state: value as AtonFilters['state'],
              }))
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All States</SelectItem>
              <SelectItem value="1">Healthy</SelectItem>
              <SelectItem value="2">Warning</SelectItem>
              <SelectItem value="3">Critical</SelectItem>
              <SelectItem value="0">Unknown</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Clear Filters Button */}
        <div className="pt-2 border-t">
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() =>
              setAtonFilters({
                type: 'all',
                state: 'all',
                owner: 'all',
              })
            }
            disabled={activeFiltersCount === 0}
          >
            Clear Filters
          </Button>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
